import { render, staticRenderFns } from "./LoginRegisterPage.vue?vue&type=template&id=d44eb1f2&scoped=true&"
import script from "./LoginRegisterPage.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterPage.vue?vue&type=style&index=0&id=d44eb1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44eb1f2",
  null
  
)

export default component.exports